import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const DraggableImage = ({
  id,
  image,
  containerId,
  onRemove,
  onPreviewClick,
  isOverlay = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    data: { photo: image, containerId },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? "none" : transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging || isOverlay ? 50 : "auto",
    touchAction: "none",
    ...(isOverlay && {
      width: "6rem",
      height: "6rem",
      border: "1px solid #404040",
      borderRadius: "0.25rem",
      overflow: "hidden",
      boxShadow:
        "0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3)",
    }),
  };

  const src = image.thumbSrc || image.baseUrl || "";

  return (
    // The parent div is no longer a 'group'
    <div ref={setNodeRef} style={style} className="relative w-full h-full">
      <img
        {...attributes}
        {...listeners}
        src={src}
        alt={image.label || "Uploaded image"}
        title="Drag to sort"
        className="w-full h-full object-cover cursor-grab active:cursor-grabbing"
        draggable={false}
      />

      {/* --- Zoned Hover Buttons --- */}

      {/* Zone 1: Top-Right Remove Button */}
      {!isOverlay && onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          // This button is positioned in the corner and appears on its own hover.
          className="absolute top-1 right-1 bg-black bg-opacity-50 text-white text-xs leading-none font-bold w-5 h-5 flex items-center justify-center rounded-full opacity-0 hover:opacity-100 transition-opacity"
          title="Remove photo"
        >
          ✕
        </button>
      )}

      {/* Zone 2: Centered Preview Button */}
      {!isOverlay && onPreviewClick && (
        <div
          // This transparent div acts as the hover zone for the centered button
          // It ignores mouse events unless the button itself is hovered.
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              onPreviewClick();
            }}
            // The button becomes visible on its own hover.
            className="bg-black bg-opacity-50 text-white text-lg leading-none w-7 h-7 flex items-center justify-center rounded-full opacity-0 hover:opacity-100 transition-opacity pointer-events-auto"
            title="Preview full-size"
          >
            👁️
          </button>
        </div>
      )}
    </div>
  );
};

export default DraggableImage;
